import { render, staticRenderFns } from "./index.vue?vue&type=template&id=be962f1c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be962f1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be962f1c')) {
      api.createRecord('be962f1c', component.options)
    } else {
      api.reload('be962f1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=be962f1c&scoped=true&", function () {
      api.rerender('be962f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/luckyFairness/index.vue"
export default component.exports